import { createSlice } from '@reduxjs/toolkit';
import { newPassword } from '../../reducers/account/accountThunks';
import { handleRequestThunk } from '../handleRequestThunk';
const SLICE_NAME = 'newPassword';

export const newPasswordSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: {},
        isLoading: false,
        error: null,
    },
    extraReducers: builder => {
        handleRequestThunk({ builder, request: newPassword });
    },
});

export const selectNewPasswordAccountData = state => state.newPassword.data;
export const selectNewPasswordAuthError = state => state.newPassword.error;
export const selectNewPasswordAuthLoading = state =>
    state.newPassword.isLoading;

export const newPasswordReducer = newPasswordSlice.reducer;
